<template>
    <div class="scc-drawing-result-alternative">
        <p v-if="text" class="scc-drawing-result-alternative__text">{{ text }}</p>
        <template v-if="show">
            <template
                v-if="publishedDrawing && publishedDrawing.winningTickets && publishedDrawing.winningTickets.length > 0"
            >
                <h2>Trekkingsuitslag {{ gameName }}</h2>
                <div class="scc-drawing-result-alternative__result-list">
                    <div class="scc-drawing-result-alternative__result-header">
                        <div class="scc-drawing-result-alternative__result-number-container">
                            <p class="scc-drawing-result-alternative__result-number bold">Lotnummer</p>
                        </div>
                        <p class="scc-drawing-result-alternative__result-prize bold">Prijs</p>
                    </div>
                    <template v-for="(result, i) in publishedDrawingPaginatedData">
                        <div :key="i" class="scc-drawing-result-alternative__result">
                            <div class="scc-drawing-result-alternative__result-number-container">
                                <p class="scc-drawing-result-alternative__result-number bold">
                                    {{ result.ticketCode }}
                                </p>
                            </div>
                            <p class="scc-drawing-result-alternative__result-prize">{{ result.prizeReference }}</p>
                        </div>
                    </template>
                </div>
                <Pagination
                    :totalPages="publishedDrawingPageCount"
                    :total="publishedDrawing.winningTickets.length"
                    :currentPage="publishedDrawingPageNumber"
                    :perPage="limit"
                    @pagechanged="onPageChange"
                />
                <p v-if="textBottom" class="scc-drawing-result-alternative__text-bottom">
                    {{ textBottom }}
                </p>
            </template>
            <template
                v-if="
                    publishedParentDrawing &&
                        publishedParentDrawing.winningTickets &&
                        publishedParentDrawing.winningTickets.length > 0
                "
            >
                <h2>Trekkingsuitslag {{ parentGameName }}</h2>
                <div class="scc-drawing-result-alternative__result-list">
                    <div class="scc-drawing-result-alternative__result-header">
                        <div class="scc-drawing-result-alternative__result-number-container">
                            <p class="scc-drawing-result-alternative__result-number bold">Lotnummer</p>
                        </div>
                        <p class="scc-drawing-result-alternative__result-prize bold">Prijs</p>
                    </div>
                    <template v-for="(result, i) in publishedParentDrawingPaginatedData">
                        <div :key="i" class="scc-drawing-result-alternative__result">
                            <div class="scc-drawing-result-alternative__result-number-container">
                                <p class="scc-drawing-result-alternative__result-number bold">
                                    {{ result.ticketCode }}
                                </p>
                            </div>
                            <p class="scc-drawing-result-alternative__result-prize">{{ result.prizeReference }}</p>
                        </div>
                    </template>
                </div>
                <Pagination
                    :totalPages="publishedParentDrawingPageCount"
                    :total="publishedParentDrawing.winningTickets.length"
                    :currentPage="publishedParentDrawingPageNumber"
                    :perPage="limit"
                    @pagechanged="onParentPageChange"
                />
                <p v-if="textBottom" class="scc-drawing-result-alternative__text-bottom">
                    {{ textBottom }}
                </p>
            </template>
        </template>
        <template v-else>
            <p class="scc-drawing-result-alternative__title h5">{{ noWinnersText }}</p>
        </template>
    </div>
</template>

<script>
import './drawing-result-alternative.scss';
import Pagination from '../global/Pagination';

export default {
    name: 'DrawingResultAlternative',
    components: { Pagination },
    __editor: {
        requiredData: ['game', 'parentGame', 'drawings', 'parentDrawings'],
    },
    props: {
        game: {
            type: Object,
            required: true,
        },
        parentGame: {
            type: Object,
            required: true,
        },
        drawings: {
            type: Array,
            required: true,
        },
        parentDrawings: {
            type: Array,
            required: true,
        },
        text: {
            type: String,
            default: '',
        },
        textBottom: {
            type: String,
            default: '',
        },
        limit: {
            type: Number,
            default: 12,
        },
        noWinnersText: {
            type: String,
            default: 'Er zijn nog geen winnaars bekend',
        },
    },
    data() {
        return {
            publishedDrawingPageNumber: 1,
            publishedParentDrawingPageNumber: 1,
        };
    },
    computed: {
        parentGameName() {
            return this.parentGame?.name;
        },
        gameName() {
            return this.game?.name;
        },
        show() {
            if (this.drawings.length > 0) return this.publishedDrawing && this.publishedParentDrawing;
            else return this.publishedParentDrawing;
        },
        publishedParentDrawing() {
            const drawings = [...this.parentDrawings];
            return drawings.find(drawing => {
                return drawing.status && drawing.status === 'published';
            });
        },
        publishedDrawing() {
            const drawings = [...this.drawings];
            return drawings.find(drawing => {
                return drawing.status && drawing.status === 'published';
            });
        },
        publishedDrawingPageCount() {
            return Math.ceil(this.publishedDrawing?.winningTickets?.length / this.limit);
        },
        publishedParentDrawingPageCount() {
            return Math.ceil(this.publishedParentDrawing?.winningTickets?.length / this.limit);
        },
        publishedDrawingPaginatedData() {
            const start = (this.publishedDrawingPageNumber - 1) * this.limit,
                end = start + this.limit;
            return this.publishedDrawing?.winningTickets?.slice(start, end);
        },
        publishedParentDrawingPaginatedData() {
            const start = (this.publishedParentDrawingPageNumber - 1) * this.limit,
                end = start + this.limit;
            return this.publishedParentDrawing?.winningTickets?.slice(start, end);
        },
    },
    methods: {
        onPageChange(page) {
            this.publishedDrawingPageNumber = page;
        },
        onParentPageChange(page) {
            this.publishedParentDrawingPageNumber = page;
        },
    },
};
</script>
